<section class="reset-page">
  <aside class="reset-page__brand">
    <div class="reset-page__brand-pattern" aria-hidden="true"></div>

    <div class="reset-page__brand-inner">
      <a class="reset-page__logo" routerLink="/" aria-label="Ir al inicio de Perrón Store">
        <img src="/images/logo/logo.png" alt="Perrón Store" />
      </a>

      <div class="reset-page__brand-copy">
        <h2 class="reset-page__tagline">Vuelve al juego</h2>
        <p class="reset-page__lead">
          Un par de pasos y estás de vuelta en tu cuenta, tus mazos y tu
          wishlist.
        </p>
      </div>

      <div class="reset-page__accent" aria-hidden="true">
        <span class="reset-page__accent-block reset-page__accent-block--foil"></span>
        <span class="reset-page__accent-block reset-page__accent-block--specialty"></span>
        <span class="reset-page__accent-block reset-page__accent-block--extended"></span>
        <span class="reset-page__accent-block reset-page__accent-block--showcase"></span>
      </div>
    </div>
  </aside>

  <div class="reset-page__content">
    @switch (state()) {
      @case ('loading') {
        <p class="reset-page__text reset-page__text--center" aria-live="polite">
          Validando enlace…
        </p>
      }

      @case ('invalid') {
        <div class="reset-page__panel reset-page__panel--status">
          <span class="reset-page__status-icon" aria-hidden="true">
            <app-icon [icon]="warningIcon" [size]="56" color="currentColor" />
          </span>
          <h1 class="reset-page__title">Este enlace ya no sirve</h1>
          <p class="reset-page__text">
            Puede haber caducado o ya fue utilizado. Pide uno nuevo y te lo
            enviamos al correo.
          </p>
          <app-button variant="primary" size="md" (click)="openForgotModal()">
            Solicitar uno nuevo
          </app-button>
        </div>
      }

      @default {
        <div class="reset-page__panel">
          <header class="reset-page__panel-header">
            <p class="reset-page__eyebrow">Recuperar acceso</p>
            <h1 class="reset-page__title">Nueva contraseña</h1>
            <p class="reset-page__text">
              Elige una robusta que no uses en otros sitios.
            </p>
          </header>

          <form
            class="reset-page__form"
            [formGroup]="form"
            (ngSubmit)="onSubmit()"
            novalidate
          >
            <div class="reset-page__field-group">
              <app-input
                id="reset-password"
                label="Nueva contraseña"
                type="password"
                placeholder="••••••••"
                formControlName="password"
              />
              <ul
                class="reset-page__requirements"
                aria-label="Requisitos de la contraseña"
              >
                @for (req of requirements; track req.key) {
                  <li
                    class="reset-page__requirement"
                    [class.reset-page__requirement--ok]="requirementStatus()[req.key]"
                  >
                    <span class="reset-page__requirement-icon" aria-hidden="true">
                      <app-icon
                        [icon]="requirementStatus()[req.key] ? checkIcon : circleIcon"
                        [size]="14"
                        color="currentColor"
                      />
                    </span>
                    {{ req.label }}
                  </li>
                }
              </ul>
            </div>

            <app-input
              id="reset-password-confirmation"
              label="Confirmar contraseña"
              type="password"
              placeholder="••••••••"
              formControlName="password_confirmation"
            />

            @if (errorMessage()) {
              <p class="reset-page__error" role="alert">{{ errorMessage() }}</p>
            }

            <app-button
              variant="primary"
              size="lg"
              type="submit"
              [loading]="state() === 'submitting'"
              [disabled]="state() === 'submitting'"
            >
              Actualizar contraseña
            </app-button>
          </form>
        </div>
      }
    }
  </div>
</section>
